export interface TopKItem {
  label: string;
  score: number;
}
export interface NbSignal {
  signal: string;
  mmsNode: string;
  iedRef: string;
  iedName?: string;
  dataset?: string;
  status?: "present"|"absent";
  score?: number;          // confianza (softmax) de la predicción top-1
  topK?: TopKItem[];       // top-3 alternativas con score
  dsTarget?: string;       // dataset destino para el mapeo a SCL
}
export interface SclNode {
  iedName:  string;
  ldInst:   string;
  prefix:   string;
  lnClass:  string;
  lnInst:   string;
  doiName:  string;
  fc:       string;
  dataset:  string;  // nombre del DataSet donde se encontró la FCDA
  mmsPath:  string;
}
export type LayoutId = "list-right-filter"|"list-bottom-filter";
export interface LayoutTemplate {
  id: LayoutId; label: string;
  direction: "horizontal"|"vertical";
  defaultSizes: [number,number];
}
export const LAYOUT_TEMPLATES: LayoutTemplate[] = [
  { id:"list-right-filter",  label:"Lista izquierda, filtros derecha", direction:"horizontal", defaultSizes:[72,28] },
  { id:"list-bottom-filter", label:"Lista arriba, filtros abajo",      direction:"vertical",   defaultSizes:[65,35] },
];
export const DEFAULT_LAYOUT: LayoutId = "list-right-filter";
